<template>
  <div>
    <router-view :key="routerViewKey" />
    <Status v-if="false" />
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'EmptyLayout',
  components: {
    Status: () => import('../components/status/Status.vue'),
  },
  computed: {
    ...mapState('time', ['current']),
    routerViewKey() {
      return `${this.$route.fullPath}&t=${this.current}`
    },
  },
}
</script>
